import "./Spinner.style.scss";

const Spinner = () => {
  return (
    <div id="overlay">
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default Spinner;
